<template>
  <section>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="4"
        v-for="(item, index) in cartas"
        :key="index"
      >
        <v-card variant="outlined" rounded="lg" class="pa-4 d-flex align-center" style="gap: 16px">
          <v-avatar :color="item.color" variant="tonal" size="48">
            <v-icon :color="item.color">{{ item.icono }}</v-icon>
          </v-avatar>
          <div>
            <div class="text-caption text-muted">{{ item.nombre }}</div>
            <div class="text-h6 font-weight-bold">{{ item.total }}</div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>
<script>
export default {
  name: "CartasPersonalizadas",
  props: ["cartas"],
};
</script>
